import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Trash } from "lucide-react";
import React, { useState } from "react";
import { Admin_Parivartan_Delete_Buisness } from "../../../../constants";
import axios from "axios";

const BuisnessTableComponent = ({
  buisnessList,
  loading,
  setLoading,
  onRefresh,
}) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [selectedBuisnessName, SetselectedBuisnessName] = useState("");

  const handleDeleteBuisness = async () => {
    if (!selectedBuisnessName) return;

    try {
      setDeleteLoading(true);
      const response = await axios.delete(
        `${Admin_Parivartan_Delete_Buisness}/${selectedBuisnessName}`
      );

      if (response.status === 200) {
        console.log("Buisness deleted successfully");
        setDeleteModalOpen(false);
        onRefresh();
      } else {
        console.error("Failed to delete buisness");
      }
    } catch (error) {
      console.error("Error deleting buisness:", error);
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <>
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: "hidden" }}>
        <Box p={0}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "grey.100" }}>
                  <TableCell sx={{ fontWeight: 600 }}>ID</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: 600 }} width="50">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {buisnessList.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 6 }}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        gap={1}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={48}
                          height={48}
                          fill="none"
                          viewBox="0 0 24 24"
                          style={{ color: "#bdbdbd", marginBottom: 8 }}
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                          />
                        </svg>
                        <Typography color="text.secondary">
                          No Buisnessess found
                        </Typography>
                        <Typography variant="body2" color="text.disabled">
                          Try adjusting your search or filters
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  buisnessList.map((buisness, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Typography variant="body2">{index + 1}.</Typography>
                      </TableCell>

                      <TableCell>
                        <Typography variant="body2" fontWeight="500">
                          {buisness.name}
                        </Typography>
                      </TableCell>

                      <TableCell width="50">
                        <Button
                          size="small"
                          variant="outlined"
                          color="error"
                          startIcon={<Trash size={18} color="red" />}
                          onClick={(e) => {
                            e.stopPropagation();
                            SetselectedBuisnessName(buisness.name);
                            setDeleteModalOpen(true);
                          }}
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>

      {/* Delete Confirmation Modal */}
      <Dialog
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Delete Buisness</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete the buisness{" "}
            <Box component="span" fontWeight="bold" display="inline">
              {selectedBuisnessName}
            </Box>
            ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeleteModalOpen(false)}
            disabled={deleteLoading}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteBuisness}
            color="error"
            disabled={deleteLoading}
            variant="contained"
          >
            {deleteLoading ? (
              <>
                <CircularProgress size={18} sx={{ mr: 1 }} />
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BuisnessTableComponent;
